<template>
<div id="app">

    <div class="margin-center" style="min-width: 1220px;">
        <div v-for="(item, index) in parts" :key="index" style="height:164px;margin-bottom: 10px;">
            <el-image style="width:100%;height:100%;" :src="item.ImageUrl" fit="cover"></el-image>
        </div>
    </div>

    <div class=" bg-white margin-center   backgroud margin-top-15" style="padding-top:10px; min-height: 550px;">
        <div v-if="length>1" class="  width flex flex-wrap bg-white " style="margin:0px auto 10px">
            <p @click="checkCatalogsItem(index)" v-for="(item, index) in catalogs" :key="index" class="font-size-16  catalogs padding-l-r-20" :class="checkIndex == index?'font-color-red':'font-color-666-red'" style="line-height:30px;cursor: pointer;text-decoration:none">{{item.Name}}</p>
        </div>
        <div class="flex flex-wrap">
            <div v-for="(item, index) in dataList" :key="index">
                <div class="backhover" @mouseover="mouseover(index)" @mouseleave="mouseout()">

                    <el-image class="image" :src="item.ImageUrl" fit="scale-down"></el-image>
                    <p class="font-color-333-red text-line1  font-size-16" style="text-decoration: none;text-align: left;line-height: 20px;height: ; margin-top: 15px; z-index: 300;cursor: pointer;">{{item.BookName}}</p>
                    <p class="text-line1 font-color-999 text-left font-size-12" style="margin-top:3px; "> 作者：{{item.Author}}</p>

                    <div class="des" v-if="index == checkBook">
                        <p class=" download" style="cursor: pointer;" @click="downloadUrl(item.DownloadUrl)">
                            <img src="../../assets/img/download.png" alt="" style="    width: 13px;
    height: 12px;">
                            下载
                        </p>
                        <div class="bg-white" style="padding:0 10px 10px;margin-top:28px">
                            <p :title="item.BookName" class="font-color-333-red text-line1  font-size-16" style="text-decoration: none;text-align: left;line-height: 20px;margin-top: 15px; z-index: 300;">{{item.BookName}}</p>
                            <p class="text-line1 font-color-999 text-left font-size-12" style="margin-top:2px; "> 作者：{{item.Author}}</p>

                            <p class=" font-color-999 text-left font-size-12">ISBN：{{item.ISBN}}
                            </p>

                            <!--   <p class=" font-color-999 text-left ">出版社：{{item.Publisher}}
                            </p>-->
                            <p :title="'书籍简介：'+item.Introduction" style="cursor: pointer;" class=" font-color-999 text-left text-3 margin-top-15">书籍简介：{{item.Introduction}}
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div style=" margin-top: 20px; ">
        <el-pagination @size-change="handleSizeChange" :current-page.sync="currentPage" @current-change="handleCurrentChange" :page-size="1" layout="prev, pager, next" :total="totalPage">
        </el-pagination>
    </div>
    <Bottom></Bottom>
</div>
</template>

<script>
export default {
  name: 'app',

  data () {
    return {
      show: true,
      checkIndex: 0,
      checkBook: -1,
      parts: [],
      catalogs: [{
        'Id': 3040,
        'Name': '全部',
        'ParentId': 1,
        'Level': 1,
        'Order': 'amet'
      }],
      currentPage: 1,
      dataList: [],
      totalPage: 1

    }
  },
  computed: {
    length () {
      return this.catalogs.length
    }
  },
  created () {
    this.getParts()
    this.getCatalogs()
    this.getCourseList(1)
  },
  methods: {
    checkCatalogsItem (index) {
      if (this.checkIndex != index) {
        this.checkIndex = index
        this.getCourseList(1)
        this.currentPage = 1
      }
    },
    downloadUrl (path) {
      // window.location.href = this.rec_book_list[index].DownloadUrl
      window.open(path, '_blank')
    },
    mouseout () {
      this.checkBook = -1
    },
    mouseover (index) {
      this.checkBook = index
    },
    handleSizeChange (val) {

    },
    handleCurrentChange (val) {
      window.scrollTo(0, 0)
      this.getCourseList(val)
    },
    clickCatalogs (index, id) {
      if (index !== this.checkIndex) {
        this.checkIndex = index
        this.getCourseList(1)
      }
    },
    // 获取头部部件
    // 获取头部部件
    getParts () {
      var that = this
      this.getRequest('api/v1/parts/', {
        CatalogId: this.catalogs[this.checkIndex].Id
      }).then(data => {
        if (data.IsSuccess) {
          that.parts = data.Data
        } else {
          this.$message.error(data.Message)
        }
      })
    },
    getCatalogs () {
      var that = this
      this.getRequest('api/v1/catalogs/', {
        Id: this.catalogs[this.checkIndex].Id
      }).then(data => {
        if (data.IsSuccess) {
          var list = []
          for (var i = 0; i < data.Data.length; i++) {
            if (data.Data[i].Level == 2) {
              list.push(data.Data[i])
            }
          }
          list = that.catalogs.concat(list)
          that.catalogs = list
        } else {
          this.$message.error(data.Message)
        }
      })
    },
    getCourseList (index) {
      var that = this
      this.getRequest('api/v1/bookinfo/', {
        CatalogId: this.catalogs[this.checkIndex].Id,
        PageIndex: index,
        PageSize: 15
      }).then(data => {
        if (data.IsSuccess) {
          that.dataList = data.Data.DataList
          that.totalPage = data.Data.TotalPage
        } else {
          this.$message.error(data.Message)
        }
      })
    }

  }
}
</script>

<style scoped>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    display: flex;
    flex-direction: column;
    justify-content: center;

}

body {
    background: #ffffff;
    padding: 0 0;
}

.text-3 {

    height: 60px;
    line-height: 20px;
    overflow: hidden;

}

.backgroud {
    width: 1220px;

    background: #ffffff;
    box-shadow: 0px 3px 20px 0px #ececec;

}

.backhover {
    width: 226px;
    height: 294px;
    padding: 10px;

    margin-left: 15px;
    position: relative;
}

.backhover .image {
    width: 208px;
    height: 208px;
}

.backhover .des {
    position: absolute;
    top: 0px;
    height: auto;
    width: 226px;

    left: 0px;
    z-index: 20;

}

.backhover .des::after {
    position: relative;
    content: " ";
    width: 200%;
    height: 200%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: inherit;
    transform: scale(0.5);
    transform-origin: 0 0;
    pointer-events: none;
    box-sizing: border-box;
    border: 1px solid #EBEBEB;
}

.backhover .des .download {
    width: 69px;
    height: 32px;
    line-height: 32px;
    color: #ffffff;
    font-size: 14px;
    margin-left: 150px;
    margin-top: 179px;
    background: #d30000;
    border-radius: 4px;
    z-index: 200px;
}

.backhover .des div,
p {
    text-decoration: none;
    z-index: 200px;
}
</style>



// WEBPACK FOOTER //
// src/views/redread/redread.vue